import React from "react";
import "./RegistrationBox.css";
import { RegistrationTitle } from "./Titles";
import { Card } from "antd";

const RegistrationBox = ({ children, title, lead, className, ...params }) => {
  const mergedClassName = ["registration-box", className].filter(Boolean).join(" ");

  return (
    <div className={mergedClassName}>
      <Card
        bordered={false}
        style={{
          boxShadow: "none",
          borderRadius: 0,
          marginBottom: 0,
          background: "transparent",
        }}
        {...params}
      >
        {title ? (
          <div className="registration-box-heading">
            <RegistrationTitle title={title} />
            {lead ? <p className="registration-box-lead">{lead}</p> : null}
          </div>
        ) : null}
        <div className="registration-box-body">{children}</div>
      </Card>
    </div>
  );
};

export default RegistrationBox;
